import { MARQUEE_ITEMS } from "../constants/site";

export default function MarqueeStrip() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="marquee relative overflow-hidden border-y border-charcoal-900/10 bg-charcoal-900 py-5"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-serif text-lg md:text-xl ${
                i % 2 === 0 ? "italic text-oat-100" : "text-oat-100/70"
              }`}
            >
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sage-500" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
